<template>
    <div>

        <div id="page">
            <div style="max-width: 1920px;">
                <b-carousel
                        id="carousel-1"
                        :interval="4000"
                        controls
                        fade
                        indicators
                        background="#ababab"
                        img-width="1024"
                        img-height="800"
                        style="text-shadow: 1px 1px 2px #333;"
                >
                    <!-- Text slides with image -->
                    <b-carousel-slide
                            v-for="(item,index) in bannerList"
                            caption=""
                            :key="index"
                            text=""
                            :img-src="item.pic"
                    ></b-carousel-slide>

                </b-carousel>
            </div>

            <!-- Start Slider Area -->


            <!-- End Slider Area -->
<!--            <header id="gtco-header" class="gtco-cover" role="banner" style="background-image:url(/static/img/banner/位图.png);">-->
<!--                <div class="overlay"></div>-->
<!--                <div class="gtco-container">-->
<!--                    <div class="row">-->
<!--                        <div class="col-md-12 col-md-offset-0 text-left">-->
<!--                            <div class="display-t">-->
<!--                                <div class="display-tc">-->
<!--                                    <h1 class="animate-box" data-animate-effect="fadeInUp">Your Business To The Next Level</h1>-->
<!--                                    <h2 class="animate-box" data-animate-effect="fadeInUp">Free HTML5 Bootstrap Templates Made</h2>-->
<!--                                    <p class="animate-box" data-animate-effect="fadeInUp"><a href="#" class="btn btn-white btn-lg btn-outline">Get In Touch</a></p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </header>-->


            <div id="gtco-features">
                <div class="gtco-container">
                    <div class="row wow fadeInUp" data-wow-delay="0s" data-wow-duration="1000ms" style="margin-top: 30px;">
                        <div class="col-md-8 col-md-offset-2 text-center gtco-heading" style="margin-bottom: 10px;">
                            <h2>定义人间绿色“烟火气”—广州双枪机电设备</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <div class="feature-center" data-animate-effect="fadeIn" style="position: relative;height: auto;">
                                <carousel-component :bannerData="videos" height="auto" :interval="3000" />
                            </div>
<!--                            <div class="feature-center" data-animate-effect="fadeIn">-->
<!--                                <video id="banner-video"-->
<!--                                       type="video/mp4"-->
<!--                                       poster="/static/video/info-img.jpg"-->
<!--                                       controls-->
<!--                                       autoplay-->
<!--                                       autobuffer-->
<!--                                       width="100%"-->
<!--                                       src="/static/video/info.mov"-->
<!--                                       style="padding: 0;margin:0;">-->
<!--                                </video>-->
<!--                            </div>-->
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="gtco-container">
                    <div class="row wow fadeInUp"  data-wow-delay="0s" data-wow-duration="1000ms">
                        <div class="col-md-8 col-md-offset-2 text-center gtco-heading" style="margin-bottom: 10px;">
                            <h2>企业新闻</h2>
                        </div>
                    </div>
                    <div class="row wow fadeInUp"  data-wow-delay="0s" data-wow-duration="1000ms">
                        <template  v-for="(item,index) in list" v-if="index<4">
                            <div class="col-md-3 col-sm-6  col-xs-12   wow fadeInUp"  data-wow-delay="0s" data-wow-duration="1000ms" :key="index">
                                <div class="list-content" style="cursor: pointer; " @click="$router.push({ path:'/shangchu/articleDetail',query:{id:item.id} })">
                                    <img :src="item.mainImgResourceUrl" width="285" height="160"/>
                                    <div class="text-tip-1">{{item.title}}</div>
                                    <div class="text-tip-2" style="font-size: 16px;"><span>{{getSpecialTime(item.releaseTime,"yyyy-MM-dd")}}</span><span style="color: rgba(6, 79, 53, 1);">详情></span></div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="buttons" @click="$router.push('/shangchu/menu2_3')">更多新闻</div>
                </div>
            </div>

            <div style="background-color: rgba(248, 248, 248, 1);padding: 50px 0 30px 0;margin-top: 50px;">
                <div class="gtco-container">
                    <div class="row wow fadeInUp"  data-wow-delay="0s" data-wow-duration="1000ms">
                        <div class="col-md-8 col-md-offset-2 text-center gtco-heading" style="margin-bottom: 10px;">
                            <h2>合作伙伴</h2>
                        </div>
                    </div>
                    <div class="row wow fadeInUp"  data-wow-delay="0s" data-wow-duration="1000ms">
                        <div style="display: flex;align-items: center;flex-wrap: wrap;display: flex;
                            display: -webkit-flex;
                            justify-content: space-between;
                            flex-direction: row;
                            flex-wrap: wrap;">
                            <template  v-for="(item,index) in 15">
                                <div style="width: 195px;margin: 20px;" :key="index">
                                    <img :src="'/static/img/home/'+item+'.png'" style="width: 195px;margin: 0 auto;" />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {articleList, getAdvertise} from "@/api/home"
    import {getSpecialTime , loadJsMethods}  from "@/utils/tools"
    import CarouselComponent from "../../components/CarouselComponent/index";


    export default {
        name: "index",
        data() {
            return {
                height:'100%',
                active:1,
                list:[],
                page:{
                    rows:0,
                    currentPage:1
                },
                bannerList:[],
                videos:[
                    {title:'双枪简介',src:'/static/video/info.mov',poster:"/static/video/info-img.jpg",type:'video'},
                    {title:'双枪简介',src:'/static/video/1016_1748935130.mp4',poster:"/static/video/415_1748933486.jpg",type:'video'},
                    // {title:'新闻',src:'/static/img/banner/WechatIMG33.jpg',type:'img'},
                    // {title:'新闻',src:'/static/img/banner/WechatIMG34.jpg',type:'img'},
                ],
            }
        },
        components: { CarouselComponent },
        watch: {},
        mounted() {
            // window.addEventListener('resize', this.changeHeight);
            // this.changeHeight();
            this.articleList();
            this.$nextTick(()=>{
                new this.$wow.WOW().init();
            })
            console.log("this.$router")
        },
        created() {
            this.getAdvertise();
        },
        methods: {
            getSpecialTime,
            changeHeight () {
                this.height = `${this.$refs.dashboardImg.offsetHeight + 80}px`;
            },
            articleList(){
                let data={
                    parentTitle:"商厨类碳标签",sonTitle:"双枪商厨新闻"
                }
                articleList(data).then(res=>{
                    console.log(res)
                    this.list = res.data.records
                    this.page.rows=res.data.total
                })
            },
            getAdvertise(){
                getAdvertise({pageNum:1,pageSize:100}).then(res=>{
                    console.log(res)
                    this.bannerList = res.data.records
                    this.page.rows=res.data.total
                });
            }
        }
    }
</script>

<style scoped>
    .container{
        font-family: SourceHanSansCN, SourceHanSansCN;
    }
    .banner-bg{
        background-repeat:no-repeat;
        background-position: center center;
    }
    .title-bg{
        background-image: url("~@/assets/images/index/模块名称装饰.png");
        height: 59px;
        width: 480px;
        text-align: center;
        margin: 10px auto 20px auto;
        line-height: 45px;
        font-size: 30px;
    }
    .project-box{
        padding:16px;
        background-color: rgba(238, 238, 238, 1);
        margin-bottom: 13px;
        line-height: 30px;
    }
    .project-box .project-box-title{
        font-size: 20px;
        color:#000000;
    }
    .project-box .project-box-content{
        fwidth: 305px;
        height: 52px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 200;
        font-size: 16px;
        color: #000000;
        line-height: 24px;
    }
    .active{
        background-color: rgba(25, 137, 68, 1);
    }
    .active .project-box-content,.active .project-box-title{
        color:#ffffff;
    }
    .tip-text{
        display: flex;
        background-color: rgba(238, 238, 238, 1);padding:10px 20px;border-radius: 20px;
        text-align: center;
        justify-content: center;
        margin: 10px;
    }
    .tip-2-title{
        background-image: url("~@/assets/images/index/低碳声明平台-素材2.png");
        height: 50px;
        width: 272px;
        text-align: center;
        line-height: 62px;
        overflow: hidden;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 16px;
        color: #198944;
    }
    .tip-3-title{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        line-height: 30px;
        display: flex;
        justify-content: center;
    }

    .tip-4-box{
        background-color: rgba(248, 248, 248, 1);
        padding: 20px 10px 10px 10px;
        margin-bottom: 20px;

    }
    .tip-4-box .tip-4-title{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        text-align: center;
    }
    .tip-4-box .tip-4-content{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 200;
        font-size: 16px;
        color: #000000;
        text-align: center;
    }
    .tip-5-box{
        text-align: center;
        margin: 20px;

    }
    .tip-6-box{
        /*background-image: url("~@/assets/images/index/编组37.png");*/
        /*width: 1200px;*/
        /*height: 500px;*/
    }

    .buttons{
        background-color: rgba(6, 79, 53, 1);color:#ffffff;width: 290px;height: 48px;font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 27px;
        font-style: normal;
        text-align: center;
        margin: 30px auto;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }


    #carousel-video .carousel-item {
        width: 1200px;
        height: 800px; /* 根据需要调整高度 */
        overflow: hidden;
    }
    .active{
        background: #ffffff;
    }
    #carousel-video .carousel-item video {
        width: 100%; /* 使视频宽度填满容器 */
        height: 100%; /* 使视频高度填满容器 */
    }
</style>
